import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Partner } from "../components/Partner";
import { Offer } from "../components/Offer";
import AOS from "aos";
import "aos/dist/aos.css";

export const Home = () => {

useEffect(() => {
    AOS.init({
        duration: 1500,
        once: true,
        disable: function () {
            return window.innerWidth < 992;
        },
    });
}, []);

return(
<div className="page-content homepage">
    <section className="wi_full py_3 banner_sec">
        <div className="container">
            <div className="row align-items-center flex-lg-row-reverse">
                <div className="col-lg-6 img_col" data-aos="fade-left">
                    <img src="./images/home-banner.png" alt="#" />
                </div>
                <div className="col-lg-6 content_col" data-aos="fade-right">
                    <div className="subtitle">We Help Find </div>
                    <h1>Health Insurance That Fits Your Life</h1>
                    <h3><strong>Simple. Personalized. Affordable.</strong>Trusted Advisors. Clear Answers. Total Support.</h3>
                    <p>Helping You Find the Right Coverage, in the Language You're Most Comfortable With</p>  
                    <div className="btn_block">
                        <a href="#scrollId" className="button fill_btn">Learn More</a>
                    </div>                      
                </div>
            </div>
        </div>
    </section>
    <section className="wi_full py_3 protect_sec position-relative" id="scrollId">
        <div className="container position-relative" data-aos="fade-up">
            <div className="row align-items-center">
                <div className="col-lg-6 img_col">
                    <img src="./images/protect-image.jpg" alt="Sewa" />
                </div>
                <div className="col-lg-6 content_col">
                    <h2>Protect What <span>Matters Most</span></h2>
                    <h3>Your Health & Family</h3>
                    <p>At Sewa Insurance, we make health insurance simple, affordable, and accessible for individuals, families, and seniors — no matter where you live or what language you speak.</p>                       
                </div>
            </div>
        </div>
    </section>
    <Offer />
    <section className="wi_full py_3 pb-0 who_we_sec position-relative" style={{backgroundImage: "url('./images/who-we-bg.jpg')",backgroundSize: "cover",
        backgroundPosition: "center", backgroundRepeat: "no-repeat",}}>
        <div className="container position-relative" data-aos="fade-up">
            <div className="row">
                <div className="col-lg-6 content_col text-white">
                    <h2 className="text-white">Who we are</h2>
                    <p>We are your local health insurance advisors, certified by the NJ state and Federal Governtment.  We help people just like you find health plans that provide peace of mind — not confusion.</p>
                    <p>With 22 years of experience and partnerships with top insurers,our team will guide individuals and families through their options with clear advice and zero jargon.</p>
                    <p>Our goal: Make your health insurance simple, stress-free, and perfectly tailored to your needs.</p>
                    <div className="btn_block">
                        <Link to="/about-us" className="button white_btn">Learn More</Link>
                    </div> 
                </div>
                <div className="col-lg-6 img_col mt-4 mt-lg-0">
                    <img src="./images/who-we-image.jpg" alt="Sewa" />
                </div>
            </div>
        </div>
    </section>
    <section className="wi_full py_3 pb-0 mt_3 lang_support_sec">
        <div className="container">
            <div className="row align-items-center flex-lg-row-reverse">
                <div className="col-lg-6 content_col" data-aos="fade-left">
                    <h2>Multilingual Support Your Language, <span>Your Comfort </span></h2>
                    <p>We’re proud to offer full service in:<br />English <br />Hindi (हिन्दी) – आपकी भाषा में हेल्थ इंश्योरेंस की जानकारी<br />Punjabi (ਪੰਜਾਬੀ) – ਤੁਹਾਡੀ ਸਹੂਲਤ ਲਈ ਪੰਜਾਬੀ ਵਿੱਚ ਸਹਾਇਤਾ</p>                       
                    <h3>Ready to find your perfect plan?</h3>
                    <div className="plan_info">
                        <h4><img src="./images/icon-calendar.svg" alt="#" />Schedule a Consultation and Book a 15-Minute Call</h4>
                        {/* <h4><img src="./images/icon-calendar.svg" alt="#" /></h4> */}
                        <h4><img src="./images/icon-phone.svg" alt="#" />Call us directly: <Link to="tel: 6462430077">(646) 243-0077</Link></h4>
                    </div>
                </div>
                <div className="col-lg-6 img_col mt-4 mt-lg-0" data-aos="fade-right">
                    <img src="./images/comfort-image.png" alt="Sewa" />
                </div>
            </div>
        </div>
    </section>
    <Partner />
</div>
)
}